const MICROSECONDS_PER_MILLISECOND = 1000;
export const MILLISECONDS_PER_SECOND = 1000;
export const SECONDS_PER_MINUTE = 60;
export const SECONDS_PER_HOUR = 60 * SECONDS_PER_MINUTE;
export const SECONDS_PER_DAY = 24 * SECONDS_PER_HOUR;
/** Converts microseconds to milliseconds. */
export const mcsToMs = (microseconds) => microseconds / MICROSECONDS_PER_MILLISECOND;
/** Converts milliseconds to microseconds. */
export const msToMcs = (milliseconds) => milliseconds * MICROSECONDS_PER_MILLISECOND;
/** Converts milliseconds to seconds, rounding up partial seconds. */
export const msToSeconds = (milliseconds) => Math.ceil(milliseconds / MILLISECONDS_PER_SECOND);
/** Converts seconds to minutes. */
export const secondsToMinutes = (seconds) => seconds / SECONDS_PER_MINUTE;
/** Converts seconds to hours. */
export const secondsToHours = (seconds) => seconds / SECONDS_PER_HOUR;
/** Converts seconds to days. */
export const secondsToDays = (seconds) => seconds / SECONDS_PER_DAY;
//# sourceMappingURL=time-units.util.js.map